import React from 'react';
import { useNavigate } from 'react-router-dom';
import RecoverPasswordSuccessSVG from 'src/assets/svg/recover-password-success.svg';
import { Button } from 'src/components';

const RecoverPasswordSuccess = () => {
  const navigate = useNavigate();
  return (
    <div className='h-full w-6/12 m-auto p-20 flex justify-center items-center flex-col gap-8'>
      <RecoverPasswordSuccessSVG className='w-100 h-100 stroke-1 my-auto' />

      <div className='text-center w-100'>
        <h1 className='text-lg p-0 m-0'>
          Your password recovery email has been sent!
        </h1>
        <p className='text-base p-0 m-0 px-2'>
          If you have an active account with us, check your inbox for password
          recovery instructions
        </p>
      </div>

      <div className='w-100'>
        <Button
          variant='black'
          classes='w-full'
          onClick={() => navigate('/login')}
        >
          Back to Login
        </Button>
      </div>
    </div>
  );
};

export default RecoverPasswordSuccess;
